module.exports = __webpack_public_path__ + "static/media/more-inactive.d17b8004.svg";